import { PREFIX } from "@/shared/template-properties/model/prefix";

export function transformPropertyToInterpolatedProperty(property: string) {
  return PREFIX + "{" + property + "}";
}
